import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import './HeroCarousel.css';

function HeroCarousel() {
  const ref = useRef(null);
  const { scrollY } = useScroll();

  // Parallax Effect: Moves the background slightly on scroll
  const yBackground = useTransform(scrollY, [0, 300], ["0%", "-10%"]);

  return (
    <motion.div
      ref={ref}
      className="hero-carousel"
      style={{ y: yBackground }} // Adds scrolling effect
    >
      <div className='caurselhead'>Bestowing legal Solutions, <br/>through Professional Excellence</div>
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }} // Slight delay for smoothness
      >
        
        {/* <p>Your Trusted Legal Partners</p> */}
      </motion.div>
    </motion.div>
  );
}

export default HeroCarousel;
